export class CompanySalesHistoryItem {
  private ean: string;
  private productName: string;
  private soldItemCount: number;
  private stateName: string;
  private city: string;
  private district: string;
  private networkName: string;
  private networkFiscalNumber: string;
  private soldValueCount: number;

  setEan(value: string): void {
    this.ean = value;
  }

  getEan(): string {
    return this.ean;
  }

  setProductName(value: string): void {
    this.productName = value;
  }

  getProductName(): string {
    return this.productName;
  }

  setSoldItemCount(value: number): void {
    this.soldItemCount = value;
  }

  getSoldItemCount(): number {
    return this.soldItemCount;
  }

  setStateName(value: string): void {
    this.stateName = value;
  }

  getStateName(): string {
    return this.stateName;
  }

  setCity(value: string): void {
    this.city = value;
  }

  getCity(): string {
    return this.city;
  }

  setDistrict(value: string): void {
    this.district = value;
  }

  getDistrict(): string {
    return this.district;
  }

  setNetworkName(value: string): void {
    this.networkName = value;
  }

  getNetworkName(): string {
    return this.networkName;
  }

  setNetworkFiscalNumber(value: string): void {
    this.networkFiscalNumber = value;
  }

  getNetworkFiscalNumber(): string {
    return this.networkFiscalNumber;
  }

  setSoldValueCount(value: number): void {
    this.soldValueCount = value;
  }

  getSoldValueCount(): number {
    return this.soldValueCount;
  }
}
